import { useForm, usePage, Link } from "@inertiajs/react";
import AppLayout from "@/layout/AppLayout";
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";
import { EventFormFields } from "./New";

export default function EventEdit() {
  const { event, teams = [], errors: serverErrors = {} } = usePage().props;

  const form = useForm({
    title:         event.title         ?? "",
    description:   event.description   ?? "",
    location_name: event.location_name ?? "",
    address:       event.address       ?? "",
    latitude:      event.latitude      ?? "",
    longitude:     event.longitude     ?? "",
    starts_at:     toDatetimeLocal(event.starts_at),
    ends_at:       toDatetimeLocal(event.ends_at),
    is_public:     event.is_public     ?? true,
    player_limit:  event.player_limit  ?? "",
    team_id:       event.team_id       ?? "",
  });

  const errors = { ...serverErrors, ...form.errors };

  function submit(e) {
    e.preventDefault();
    form.patch(event.paths.update);
  }

  return (
    <AppLayout>
      <div className="container py-8 max-w-2xl mx-auto">
        <Button asChild variant="ghost" size="sm" className="mb-4 -ml-1 text-muted-foreground">
          <Link href={event.paths.show}>
            <ChevronLeft className="h-4 w-4" />
            Back to event
          </Link>
        </Button>

        <h1 className="text-2xl font-bold mb-6">Edit event</h1>

        <form onSubmit={submit} className="space-y-5">
          <EventFormFields form={form} errors={errors} teams={teams} />

          <div className="flex gap-3 pt-2">
            <Button type="submit" disabled={form.processing}>
              {form.processing ? "Saving…" : "Save changes"}
            </Button>
            <Button asChild variant="ghost">
              <Link href={event.paths.show}>Cancel</Link>
            </Button>
          </div>
        </form>
      </div>
    </AppLayout>
  );
}

function toDatetimeLocal(isoString) {
  if (!isoString) return "";
  const d = new Date(isoString);
  // Format: YYYY-MM-DDTHH:MM (local time, no seconds)
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
